import React from 'react';
import { sunshineBliss, errorPalette, autumnHarvest, springMeadow, auroraGlow } from '../helpers/colorsPalette'

const DocumentCsvIcon = ({ width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#a8e063', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#56ab2f', stopOpacity: 1 }} />
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#greenGradient)" stroke="#a8e063" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#greenGradient)" stroke="#a8e063" strokeWidth="1" />
        <text x="50%" y="50%" textAnchor="middle" fill="#ffffff" fontSize="3" fontFamily="Arial" fontWeight="bold" dy=".3em">CSV</text>
    </svg>
);

const DocumentDocIcon = ({ width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#a1c4fd', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#c2e9fb', stopOpacity: 1 }} />
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#blueGradient)" stroke="#a1c4fd" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#greenGradient)" stroke="#a1c4fd" strokeWidth="1" />
        <text x="50%" y="50%" textAnchor="middle" fill="#ffffff" fontSize="3" fontFamily="Arial" fontWeight="bold" dy=".3em">DOC</text>
    </svg>
);

const DocumentExcelIcon = ({ width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#a8e063', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#56ab2f', stopOpacity: 1 }} />
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#greenGradient)" stroke="#a8e063" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#greenGradient)" stroke="#a8e063" strokeWidth="1" />
        <text x="50%" y="50%" textAnchor="middle" fill="#ffffff" fontSize="3" fontFamily="Arial" fontWeight="bold" dy=".3em">Excel</text>
    </svg>
);

const DocumentJSONIcon = ({ width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#6dd5ed', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#2193b0', stopOpacity: 1 }} />
            </linearGradient>
        </defs>

        {/* Document Shape */}
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#blueGradient)" stroke="#6dd5ed" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#blueGradient)" stroke="#6dd5ed" strokeWidth="1" />

        {/* Label */}
        <text
            x="50%"
            y="50%"
            textAnchor="middle"
            fill="#ffffff"
            fontSize="3"
            fontFamily="Arial"
            fontWeight="bold"
            dy=".3em"
        >
            JSON
        </text>
    </svg>
);

const DocumentDataIcon = ({ width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#6dd5ed', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#2193b0', stopOpacity: 1 }} />
            </linearGradient>
        </defs>

        {/* Document Shape */}
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#blueGradient)" stroke="#6dd5ed" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#blueGradient)" stroke="#6dd5ed" strokeWidth="1" />

        {/* Label */}
        <text
            x="50%"
            y="50%"
            textAnchor="middle"
            fill="#ffffff"
            fontSize="3"
            fontFamily="Arial"
            fontWeight="bold"
            dy=".3em"
        >
            {"DATA"}
        </text>
    </svg>
);

const DocumentTextIcon = ({ width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="purpleGradient" x1="0%" y1="0%" x2="100%">
                <stop offset="0%" style={{ stopColor: '#DDA0DD', stopOpacity: 1 }} />  {/* Plum */}
                <stop offset="100%" style={{ stopColor: '#BA55D3', stopOpacity: 1 }} />  {/* Medium Orchid */}
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#purpleGradient)" stroke="#DDA0DD" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#purpleGradient)" stroke="#DDA0DD" strokeWidth="1" />
        <text x="50%" y="50%" textAnchor="middle" fill="#ffffff" fontSize="3" fontFamily="Arial" fontWeight="bold" dy=".3em">Text</text>
    </svg>
);

const DocumentUploadIcon = ({ style, width = 160, height = 160 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <defs>
            <linearGradient id="sunshineBlissGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: sunshineBliss[0], stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: sunshineBliss[1], stopOpacity: 1 }} />
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#sunshineBlissGradient)" stroke={sunshineBliss[0]} strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#sunshineBlissGradient)" stroke={sunshineBliss[0]} strokeWidth="1" />
        <polygon points="11,8 7,12 9,12 9,16 13,16 13,12 15,12" fill={sunshineBliss[0]} />
    </svg>
);

const DocumentErrorIcon = ({ style, width = 160, height = 160 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <defs>
            <linearGradient id="errorGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: errorPalette[0], stopOpacity: 1 }} />  {/* Red Orange */}
                <stop offset="100%" style={{ stopColor: errorPalette[1], stopOpacity: 1 }} />  {/* Dark Orange */}
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#errorGradient)" stroke={errorPalette[0]} strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#errorGradient)" stroke={errorPalette[0]} strokeWidth="1" />
        <polygon points="11,8 7,12 9,12 9,16 13,16 13,12 15,12" fill={errorPalette[0]} />
        <text x="50%" y="50%" textAnchor="middle" fill="#ffffff" fontSize="3" fontFamily="Arial" fontWeight="bold" dy=".3em">ERROR</text>
    </svg>
);

const DocumentMiscIcon = ({ style, width = 120, height = 120 }) => (
    <svg width={width} height={height} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <defs>
            <linearGradient id="grayGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#d3d3d3', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#a9a9a9', stopOpacity: 1 }} />
            </linearGradient>
        </defs>
        <path d="M3 2H15L19 6V22H3V2Z" fill="url(#grayGradient)" stroke="#a9a9a9" strokeWidth="1" />
        <path d="M15 2V6H19" fill="url(#grayGradient)" stroke="#a9a9a9" strokeWidth="1" />
    </svg>
);

export { DocumentCsvIcon, DocumentDataIcon, DocumentJSONIcon, DocumentUploadIcon, DocumentMiscIcon, DocumentDocIcon, DocumentExcelIcon, DocumentErrorIcon, DocumentTextIcon }